import memberadminEn from '../resources/en/memberadmin.json';
import dataownerEn from '../resources/en/dataowner.json';
import employeeEn from '../resources/en/employee.json';
import errorEn from '../resources/en/error.json';
import locationEn from '../resources/en/location.json';

import memberadminNo from '../resources/no/memberadmin.json';
import dataownerNo from '../resources/no/dataowner.json';
import employeeNo from '../resources/no/employee.json';
import errorNo from '../resources/no/error.json';
import locationNo from '../resources/no/location.json';

import memberadminSv from '../resources/sv/memberadmin.json';
import dataownerSv from '../resources/sv/dataowner.json';
import employeeSv from '../resources/sv/employee.json';
import errorSv from '../resources/sv/error.json';
import locationSv from '../resources/sv/location.json';

import { MemberadminLanguageResources } from '../types/MemberadminResources';

export const memberadminI18nResources: MemberadminLanguageResources = {
  no: {
    memberadmin: memberadminNo,
    dataowner: dataownerNo,
    location: locationNo,
    employee: employeeNo,
    error: errorNo,
  },
  sv: {
    memberadmin: memberadminSv,
    dataowner: dataownerSv,
    location: locationSv,
    employee: employeeSv,
    error: errorSv,
  },
  en: {
    memberadmin: memberadminEn,
    dataowner: dataownerEn,
    location: locationEn,
    employee: employeeEn,
    error: errorEn,
  },
};
